import { render, staticRenderFns } from "./Notificacoes.vue?vue&type=template&id=a71b7800&"
import script from "./Notificacoes.vue?vue&type=script&lang=js&"
export * from "./Notificacoes.vue?vue&type=script&lang=js&"
import style0 from "./notificacao.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports